import React from 'react'
import {useIntl} from 'react-intl'
import {Text, HStack, Box, useMultiStyleConfig, TextProps} from '@chakra-ui/react'
import {srOnlyStyles} from '_themeUtils'

interface PriceProps {
    discountedPrice?: string | React.ReactNode
    discountedPriceMinRange?: string | React.ReactNode
    priceMinRange?: string | React.ReactNode
    id?: string
    currentPriceId?: string
    variant?: string
    children: string | React.ReactNode
}

const Price = ({discountedPrice, discountedPriceMinRange, priceMinRange, id, currentPriceId, variant, children}: PriceProps) => {
    const styles = useMultiStyleConfig('Price', {variant}) as Record<string, TextProps>
    const {formatMessage} = useIntl()

    const hasDiscount = Boolean(discountedPrice || discountedPriceMinRange)

    const currentPriceLabel = formatMessage({
        id: 'price.label.current',
        defaultMessage: 'Discounted price:',
    })

    const originalPriceLabel = formatMessage({
        id: 'price.label.original',
        defaultMessage: 'Original price:',
    })

    const discountedPriceMinRangeLabel = formatMessage(
        {
            id: 'label.range.price.child',
            defaultMessage: 'A partire da {0}',
        },
        {0: discountedPriceMinRange},
    )
    const priceMinRangeLabel = formatMessage(
        {
            id: 'label.range.price.child',
            defaultMessage: 'A partire da {0}',
        },
        {0: priceMinRange},
    )

    return (
        <HStack {...styles.wrapper}>
            {discountedPrice && (
                <Text {...styles.price} id={currentPriceId}>
                    {hasDiscount && (
                        <Box as="span" sx={srOnlyStyles}>
                            {currentPriceLabel}{' '}
                        </Box>
                    )}
                    {discountedPrice}
                </Text>
            )}
            {discountedPriceMinRange && (
                <Text {...styles.price} id={currentPriceId}>
                    {hasDiscount && (
                        <Box as="span" sx={srOnlyStyles}>
                            {currentPriceLabel}{' '}
                        </Box>
                    )}
                    {discountedPriceMinRangeLabel}
                </Text>
            )}
            <Text id={id} {...styles.price} {...(hasDiscount ? styles.discountedPrice : {})}>
                {hasDiscount && (
                    <Box as="span" sx={srOnlyStyles}>
                        {originalPriceLabel}{' '}
                    </Box>
                )}
                {priceMinRange ? priceMinRangeLabel : children}
            </Text>
        </HStack>
    )
}

export {Price}
